import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"

export default class LostPassword extends Component {
    render() {

    return (

      <div className="main-wrapper">
        <Header></Header>
        <div className="main-content myaccount-wrapper m-0">    
            <div className="container">
                <div className='col-md-7' style={{margin:"auto"}}>
                  <form className='form-main-wrapper'>
                    <div className='subhead'>SIGN IN</div>
                    <div className=' myaccount-form'>
                      <div className='form-group'>
                        <p><small>Lost your password? Please enter your username or email address. You will receive a link to create a new password via email.</small></p>
                      </div>
                      <div className="form-group">
                        <label for="exampleFormControlInput1">Username or email address </label>
                        <input type="email" className="form-control" />
                      </div>
                      <div className="form-group mt-4" style={{textAlign:"right"}}>
                        <button type="submit" className="btn btn-gray">Reset Password</button>
                      </div>
                    </div>
                  </form>
                </div>
            </div>
            
        </div>
        <Footer></Footer>
        
      </div>
      )
    }
}



// WEBPACK FOOTER //
// ./src/ivano/lostPassword.jsx